import { Box, IconButton, keyframes } from "@mui/material";

import { NotificationCategoryEnum } from "../../enums/notifications";
import { NotificationsNormalIcon, NotificationsOnIcon } from "../../assets/icons/notifications-icons";

import NotificationsPopover from "./NotificationsPopover";

// Pulse animation for new notifications
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

// Ripple animation for continuous attention
const ripple = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
`;

const Notifications = ({
  handleOpenNotifications,
  notificationsOpen,
  anchorEl,
  handleCloseNotifications,
  activeTab,
  setActiveTab,
  data,
  lastSeen,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  hasNewNotifications,
}: {
  handleOpenNotifications: (event: React.MouseEvent<HTMLElement>) => void;
  notificationsOpen: boolean;
  anchorEl: HTMLElement | null;
  handleCloseNotifications: () => void;
  activeTab: NotificationCategoryEnum;
  setActiveTab: (tab: NotificationCategoryEnum) => void;
  data: any;
  lastSeen?: number;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  hasNewNotifications: boolean;
}) => {
  return (
    <Box>
      <IconButton
        onClick={handleOpenNotifications}
        sx={{
          position: "relative",
          animation: hasNewNotifications ? `${pulse} 2s infinite` : "none",
          "&::before": hasNewNotifications
            ? {
                content: '""',
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                animation: `${ripple} 2s infinite`,
              }
            : {},
        }}
      >
        {hasNewNotifications ? <NotificationsOnIcon /> : <NotificationsNormalIcon />}
      </IconButton>
      <NotificationsPopover
        notificationsOpen={notificationsOpen}
        anchorEl={anchorEl}
        onClose={handleCloseNotifications}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        data={data}
        lastSeen={lastSeen}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </Box>
  );
};

export default Notifications;
